import Image from 'next/image'

import { FC } from 'react'

import { AnimationMoveIconComponent } from '@/app/shared/components/animation/move-icon'
import { AnimationShowBlockComponent } from '@/app/shared/components/animation/show-block'
import { IconBgPart } from '@/app/shared/icons'
import { IId } from '@/app/shared/interfaces/common.interface'
import { IDescription, IImg, ISubTitle, ITitle } from '@/app/shared/interfaces/content.interface'
import { ContainerComponent } from '@/app/shared/ui/container'
import { TitleComponent } from '@/app/shared/ui/title'

// interface
interface IGuarantees extends IId {
  data: IGuaranteesQuery
}

export interface IGuaranteesQuery {
  title: ITitle
  image: IImg
  subTitle: ISubTitle
  description: IDescription[]
}

// component
const GuaranteesComponent: FC<Readonly<IGuarantees>> = ({ data, id }) => {
  // return
  return (
    <ContainerComponent id={id}>
      <div
        className={
          'relative grid gap-[30px] bg-secondary p-[30px] extraMobile:p-10 laptop:grid-cols-[232px_1fr] laptop:gap-[50px] desktop:grid-cols-[430px_1fr] desktop:p-[60px_80px_60px_50px]'
        }
      >
        <div className={'flex flex-wrap justify-between laptop:flex-col'}>
          <TitleComponent typeTag={data.title.size} className={'mb-auto text-content1-600'} animate>
            {data.title.title}
          </TitleComponent>
          <AnimationMoveIconComponent
            className={
              'relative mt-3 h-[92px] w-[114px] laptop:h-[102px] laptop:w-[128px] desktop:mt-5 desktop:h-[158px] desktop:w-[197px]'
            }
            valueMoving={55}
            initial={{
              opacity: 0,
            }}
            whileInView={{
              opacity: 1,
            }}
          >
            <Image src={data.image?.image} alt={'guarantee'} fill />
          </AnimationMoveIconComponent>
        </div>
        <AnimationShowBlockComponent
          typeTag={'p'}
          initial={{
            opacity: 0,
            y: 30,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          className={'grid gap-5 text-content1-700'}
        >
          <span className={'text-[18px] desktop:text-[22px]'}>
            {data.description[0].description}
            <span className={'font-bold text-content1-200'}> {data.subTitle.subTitle}</span>
          </span>
          <span>{data.description[1].description}</span>
          <span>{data.description[2].description}</span>
        </AnimationShowBlockComponent>
        <IconBgPart className={'absolute -top-[36px] right-0 h-[37px] w-[53px] text-secondary'} />
      </div>
    </ContainerComponent>
  )
}

export default GuaranteesComponent
